import { flags } from './config'

export function getFlags() {
  return process.server ? process.flags : flags
}
